module.exports = __webpack_public_path__ + "static/media/100x800_PT2.5a9875b7.gif";